
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/[...recipeSlug]",
      function () {
        return require("private-next-pages/recipes/[...recipeSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/[...recipeSlug]"])
      });
    }
  